module.exports = __webpack_public_path__ + "img/logo.2df045f2.png";